import React from "react"

function HeaderA() {
  return (
    <svg fill="none" viewBox="0 0 266 150">
      <path fill="var(--solid)" d="M0 0h266v150H0z" />
      <path stroke="var(--base-300)" d="M266 38.5H0" />
      <rect
        x={217}
        y={14}
        width={29}
        height={10}
        rx={2}
        fill="var(--base-400)"
      />
      <circle cx={29} cy={19} r={9} fill="var(--main-500)" />
      <rect
        x={150.132}
        y={17}
        width={16.604}
        height={4}
        rx={2}
        fill="var(--solid-900)"
      />
      <rect
        x={171.264}
        y={17}
        width={16.604}
        height={4}
        rx={2}
        fill="var(--solid-900)"
      />
      <rect
        x={192.396}
        y={17}
        width={16.604}
        height={4}
        rx={2}
        fill="var(--solid-900)"
      />
      <rect
        x={129}
        y={17}
        width={16.604}
        height={4}
        rx={2}
        fill="var(--solid-900)"
      />
    </svg>
  )
}

export default HeaderA;
